// Completion types for OpportunitySecurityCompletion entries. Mirrors the backend
// OpportunitySecurityCompletionConstants / DB CHECK constraint.
const OpportunitySecurityCompletionTypeEnum = {
  DataTransfer: 'DataTransfer',
  DataErasure: 'DataErasure',
};

export default OpportunitySecurityCompletionTypeEnum;
